import AllCourse from './AllCourse.gql';
import { COURSE_COLUMN } from './constants';

export { COURSE_COLUMN };
export default AllCourse;
